import { Contacts } from './contacts.model';
import { Files } from './file.model';
import { Notes } from './notes.model';

export class Customers {
    id: string;
    company: string;
    licenseCount: number;
    expirationDate: Date;
    status: string;
    licenseType: string;
    license: string;
    instanceId: string;
    contacts: Contacts[];
    notes: Notes[];
    files: Files[];

    constructor() {
        this.id = '';
        this.company = '';
        this.licenseCount = 0;
        this.expirationDate = null;
        this.status = '';
        this.licenseType = 'Enterprise';
        this.license = '';
        this.instanceId = '';
        this.contacts = [];
        this.notes = [];
        this.files = [];
    }
}